import { Component, OnInit, Input } from '@angular/core';
import { Validators, AbstractControl, ValidationErrors, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from 'src/app/shared/form_Validation/form-validator.service';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomValidator } from 'src/app/shared/services/custom-validator.service';
import { CookieService } from 'ngx-cookie-service';
import { DomSanitizer } from '@angular/platform-browser';
import {MatDialog} from '@angular/material/dialog';
// import { UploadPhotoComponent } from '../upload-photo/upload-photo.component';
import { state } from '@angular/animations';
import { UploadPhotoComponent } from '../upload-photo/upload-photo.component';
import { PasswordWarningComponent } from 'src/app/shared/password-warning/password-warning.component';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { lengths } from 'src/app/shared/DataLengths';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  imageChangedEvent: any = '';

  croppedImage: any = '';
  AddressDetails;
  country: any;
  PersonalDetails: FormGroup;
  tabvisBusTab = 0;
  tabvis = 0;
  imgsrc: any;
  backupZipDetailsPer: any;
  phoneTypeList = [];
  editprofileData = [];
  tempprofileData = [];
  address_id = '';
  temp_zipcode = '';
  zipcode_id = '';
  edit = false;
  is_correct_zip : any
  isRestricted: any;
  isRestrictedUser = false;
  phoneTypeName;
  @Input() selectedIndex: number | null = 0;

  constructor(private route: ActivatedRoute, private router: Router, private dialog: MatDialog,
    private _api: ApiService
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private spinner: NgxSpinnerService
    , private customValidator: CustomValidator
    , private utils : UtilitiesService
    , private cookieService: CookieService
    , private sanitizer: DomSanitizer) {

    this.AddressDetails = this.formBuilder.group({
      user_zip_code: new FormControl({ value: '', disabled: true }, [Validators.required, this.validZipCode]),
      state: new FormControl({ value: '', disabled: true }),
      county: new FormControl({ value: '', disabled: true }),
      country: new FormControl({ value: '', disabled: true }, [Validators.required]),
      city: new FormControl({ value: '', disabled: true }),
      street_number: new FormControl({ value: '', disabled: true }, [Validators.required,
         Validators.maxLength(lengths.street_number_max_length), this.customValidator.isFullSpace,
        this.customValidator.isValidStreetNum]),
      street_name: new FormControl({ value: '', disabled: true }, [Validators.required, customValidator.hasinitspace]),
      unit: new FormControl({ value: '', disabled: true }),
      cell_number: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.minLength(10) ,
      this.customValidator.isAllZero]),
      phone_type_id: new FormControl({ value: '', disabled: true }, [Validators.required]),
      zip_id: new FormControl({ value: '', disabled: true }),
      is_correct_zip: new FormControl({ value: false, disabled: true }),
      sms_opt_in_out: new FormControl('')

    });
    this.PersonalDetails = this.formBuilder.group({
      user_first_name: new FormControl({ value: '', disabled: true }, [Validators.required, customValidator.hasinitspace, customValidator.hasinitspace]),
      user_middle_name: new FormControl({ value: '', disabled: true }),
      user_last_name: new FormControl({ value: '', disabled: true }, [Validators.required, this.customValidator.hasinitspace]),
      user_email: new FormControl({ value: sessionStorage.getItem('Email'), disabled: true }),
      user_acno: [{ value: '', disabled: true }]

    });
  }
  // valid zip code
  validZipCode(control: AbstractControl): ValidationErrors | null {
    return { validZip: true };
  }

  // check password
  passwordValidator(form: FormGroup) {
    const condition = form.get('confirm_password').value !== form.get('user_password').value;
    return condition ? { passwordsDoNotMatch: true } : null;
  }


  // get phone type
  getPhoneType() {
    this._api.functionGET('phones/getPhoneType', {}).subscribe((res) => {
      this.phoneTypeList = res['data'];
    },
      err => {
      });

  }
  getExpiry() {
    const ExpiryDate = localStorage.getItem('expiry');

    if (ExpiryDate) {

      const data = {
        expiry_message: ExpiryDate
      };

      const dialogRef = this.dialog.open(PasswordWarningComponent,
        { data });
      dialogRef.afterClosed().subscribe(result => {
        localStorage.removeItem('expiry');
        if (result) {
          this.router.navigate(['current_business/Security_Settings']);
          return false;

        }
      });
    }
  }
  prepopulateData() {

    this._api.functionGET('user/getUserDetailsForEdit', {}).subscribe((res) => {
      this.editprofileData = res['data']['userData'];
      this.tempprofileData = res['data']['userData'];
      this.is_correct_zip = res['data']['incorrect_zipcode']
      this.phoneTypeName = res['data']['userData']['bt_phone_type_name'];
      // this.AddressDetails.patchValue({
      //   is_correct_zip: res['data']['incorrect_zipcode']
      // });

      this.patchData('editprofileData');


    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
      });
  }
  patchData(Data: string) {
    const isCorrectZip = this.is_correct_zip;
    // this.AddressDetailsIncorrectZip({checked : isCorrectZip});
    this.PersonalDetails.patchValue({
      user_first_name: this[Data]['firstname'],
      user_middle_name: this.editprofileData['middlename'],
      user_last_name: this[Data]['lastname'],
      user_email: this[Data]['email'],
      user_acno: this[Data]['account_id']
    });
    this.address_id = this[Data]['bt_address_id'];
    this.zipcode_id = this[Data]['bt_zipcodes_id'];
    this.temp_zipcode = this[Data]['incorrect_zipcode'] ? this[Data]['v_bt_address']['bt_temp_zipcodes_id'] : null;
    this.AddressDetails.patchValue({
      country: isCorrectZip ? this[Data]['v_bt_address']['bt_country_id'] : this[Data]['bt_country_id'],
      state: isCorrectZip ? this[Data]['v_bt_address']['bt_temp_region'] : this[Data]['region_name'],
      city: isCorrectZip ? this[Data]['v_bt_address']['bt_temp_city'] : this[Data]['city'],
      user_zip_code: this[Data]['zipcode'],
      county: isCorrectZip ? this[Data]['v_bt_address']['bt_temp_county'] : this[Data]['county'],
      cell_number: this[Data]['phone'],
      phone_type_id: this[Data]['bt_phone_type_id'],
      unit: this[Data]['address_unit'],
      street_number: this[Data]['street_number'],
      is_correct_zip : this.is_correct_zip,
      street_name: this[Data]['address1'],
      sms_opt_in_out: this.editprofileData['is_send_sms'] === 'N' ? false : true

    });
    this.findZip();
    this.AddressDetails.updateValueAndValidity();
    this.AddressDetails.get('user_zip_code').clearValidators();
  }
  saveData() {
    if (!this.AddressDetails.valid || !this.PersonalDetails.valid) {
      return false;
    }
    const data = {
      user_phone_number: this.AddressDetails.get('cell_number').value,
      user_address1: this.AddressDetails.get('street_name').value,
      street_number: this.AddressDetails.get('street_number').value,
      phone_type_id: this.AddressDetails.get('phone_type_id').value,
      user_addr_unit: this.AddressDetails.get('unit').value,
      user_country: this.AddressDetails.get('country').value,
      user_city: this.AddressDetails.get('city').value,
      user_state: this.AddressDetails.get('state').value,
      user_county: this.AddressDetails.get('county').value,
      // temp_zipcodes_id: this.AddressDetails.get('user_zip_code').value
      user_zip_code: this.zipcode_id,
      bt_address_id: this.address_id,
      temp_zipcodes_id: this.temp_zipcode,
      incorrect_zipcode: this.AddressDetails.get('is_correct_zip').value,
      middlename : this.PersonalDetails.get('user_middle_name').value,
      lastname : this.PersonalDetails.get('user_last_name').value,
      is_opt_in: this.AddressDetails.get('sms_opt_in_out').value === true ? 'Y' : 'N'

    };
    this._api.functionPOST('user/editUser', data).subscribe((res) => {
      if (res['success']) {
        this._api.openSnackBar(res['data'], 'Success');
        this.utils.detechNameChange(true);
        this.prepopulateData();
        this.enableDisable(false);
        this.edit = false;

      }
    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
      });
  }
  enableDisable(type) {

    this.edit = type;

    const phonenumber = this.AddressDetails.get('cell_number');
    // const country = this.AddressDetails.get('country');
    // const streetnumber = this.AddressDetails.get('street_number');
    // const streetname = this.AddressDetails.get('street_name');
    // const unit = this.AddressDetails.get('unit');
    const phonetypeid = this.AddressDetails.get('phone_type_id');
    // const zipcode_valid = this.AddressDetails.get('is_correct_zip');
    // const zipcode = this.AddressDetails.get('user_zip_code');
    // const city = this.AddressDetails.get('city');
    // const county = this.AddressDetails.get('county');
    // const state = this.AddressDetails.get('state');
    // const middlename = this.PersonalDetails.get('user_middle_name');
    const lastname = this.PersonalDetails.get('user_last_name');




    if (type === true) {
      this.AddressDetailsIncorrectZip({ checked: this.AddressDetails.get('is_correct_zip').value });
      phonenumber.enable();
      // country.enable();
      // // streetnumber.enable();
      // streetname.enable();
      // unit.enable();
      phonetypeid.enable();
      // zipcode_valid.enable();
      // zipcode.enable();
      // middlename.enable();
      lastname.enable();
      // if (zipcode_valid.value) {
      //   city.enable();
      //   county.enable();
      //   state.enable();
      // }
    } else {
      // city.disable();

      // zipcode.disable();
      // county.disable();
      // state.disable();
      phonenumber.disable();
      // country.disable();
      // // streetnumber.disable();
      // streetname.disable();
      // unit.disable();
      phonetypeid.disable();
      // zipcode_valid.disable();
      // zipcode.disable();
      // middlename.disable();
      lastname.disable();

    }

  }



  // get country list
  getCountryList() {
    this._api.functionGET('country/allcountry', {}).subscribe((res) => {
      this.country = res['data'];

      this.AddressDetails.patchValue({
        country: this.country[0].bt_country_id
      });
    },
      err => {
      });
  }
  // function
  bindDropDownList() {
    this.getCountryList();
    this.getPhoneType();
    this.prepopulateData();

  }

  AddressDetailsIncorrectZip($event) {


    const city = this.AddressDetails.get('city');
    const county = this.AddressDetails.get('county');
    const state = this.AddressDetails.get('state');
    const zipcode = this.AddressDetails.get('user_zip_code');

    if ($event.checked) {
      city.enable();
      county.enable();
      state.enable();
      city.setValidators([Validators.required, this.customValidator.hasinitspace]);
      state.setValidators([Validators.required, this.customValidator.hasinitspace]);
    } else {
      city.disable();
      county.disable();
      state.disable();
      city.clearValidators();
      state.clearValidators();
      this.AddressDetails.patchValue({
        city: this.backupZipDetailsPer['city']
        , county: this.backupZipDetailsPer['county']
        , state: this.backupZipDetailsPer['bt_region']['name']
      });
    }

    city.updateValueAndValidity();
    // county.updateValueAndValidity();
    state.updateValueAndValidity();
  }
  //  find zip code
  findZip() {
    const data = {
      zipcode: this.AddressDetails.get('user_zip_code').value
      , Country: this.AddressDetails.get('country').value
    };
    const isCorrectZip = this.AddressDetails.get('is_correct_zip').value;
    this._api.functionPOST('zipcode/findZip', data).subscribe((res) => {
      if (res['data'].length === 0) {
        this._api.openSnackBar('Zip Code not found', 'Error');
        return;
      }
      this.backupZipDetailsPer = res['data'][0];
      if (!isCorrectZip) {
        this.AddressDetails.patchValue({
          city: res['data'][0].city,
          county: res['data'][0].county,
          state: res['data'][0].bt_region.name,
          zip_id: res['data'][0].bt_zipcodes_id
        });
      }
      this.AddressDetails.patchValue({
        zip_id: res['data'][0].bt_zipcodes_id
      });
      this.zipcode_id = res['data'][0].bt_zipcodes_id;
      const zipcode = this.AddressDetails.get('user_zip_code');
      zipcode.clearValidators();
      zipcode.updateValueAndValidity();
    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
        const zipcode = this.AddressDetails.get('user_zip_code');
        zipcode.setValidators([Validators.required, this.customValidator.hasinitspace, this.validZipCode]);
        zipcode.updateValueAndValidity();
      });
  }
  cancelEdit() {
    this.edit = false;
    this.patchData('tempprofileData');
    const phonenumber = this.AddressDetails.get('cell_number');
    const country = this.AddressDetails.get('country');
    // const streetnumber = this.AddressDetails.get('street_number');
    const streetname = this.AddressDetails.get('street_name');
    const unit = this.AddressDetails.get('unit');
    const phonetypeid = this.AddressDetails.get('phone_type_id');
    const zipcode_valid = this.AddressDetails.get('is_correct_zip');
    const city = this.AddressDetails.get('city');
    const county = this.AddressDetails.get('county');
    const state = this.AddressDetails.get('state');
    const zipcode = this.AddressDetails.get('user_zip_code');
    const middlename = this.PersonalDetails.get('user_middle_name');
    const lastname = this.PersonalDetails.get('user_last_name');


    city.disable();
    county.disable();
    state.disable();
    phonenumber.disable();
    country.disable();
    // streetnumber.disable();
    streetname.disable();
    unit.disable();
    phonetypeid.disable();
    zipcode_valid.disable();
    zipcode.disable();
    middlename.disable();
    lastname.disable();
  }
  getProfilePhoto() {
    this._api.fileReader('user/getUserImage', '').subscribe((response) => {
      //  this._uttil.download(response);
      this.createImage(response.data.fileurl);
    }, err => {

    });
  }
  createImage(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const url = reader.result;
      this.imgsrc = this.sanitizer.bypassSecurityTrustUrl(url as any);
    }, false);
    if (image) {
      this.imgsrc = image

      // reader.readAsDataURL(image);
    }
  }
  ngOnInit() {
    this.isValidToken();
    this.bindDropDownList();
    this.getProfilePhoto();
    this.isRestricted = (this.router.url === '/current_business/profile') ? true : false;

    setTimeout(() => {
      this.getExpiry();
    });
  }
  addPhoto() {
    const dialogRef = this.dialog.open(UploadPhotoComponent,
      {});
    dialogRef.afterClosed().subscribe(result => {
      if (
        result
      ) {
        this.getProfilePhoto();
      }

    });
  }
 isValidToken() {
    if (this.cookieService.get('token')) {
      this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
        this.isRestrictedUser = res['data']['isRestrictedUser'];
        if (res['data']['isRestrictedUser']) {
          this.router.navigate(['/current_business/profile']);
          return;
        }
        if (!res['data']['email_verified']) {
           this.router.navigate(['/']);
          this.cookieService.deleteAll('/');
          return;
        }
        // if (!res['data']['idme_verified']) {
        //   this.router.navigate(['/verification']);
        //   return;
        // }

        // if (!res['data']['membership_active']) {
        //   this.router.navigate(['/pending_approval']);
        // } else {
        if (res['data']['is_approved_once']=='N') {
          return;
        } else if (!res['data']['membership_active']) {
          // this.router.navigate(['/current_business']);
          this.router.navigate(['/pending_approval']);
        } else {
          if (res['data']['no_allowedBusinesses'] > 0) {
            this.router.navigate(['/dashboard/task-management']);
          }
        }
      });
    }
  }



  gotoBackPage() {
    // this.router.navigate(['../profile']);
    this.utils.goToBack();

  }



}
